import { useState } from 'react';

export const useIsDragActive: () => [
	boolean,
	import('react').Dispatch<import('react').SetStateAction<boolean>>,
] = () => useState<boolean>(false);
